import React from "react";

import { withTranslation, WithTranslation } from "react-i18next";
import AuthService from "../../../../../common/AuthService";
import { IMessageBoxParams } from "../../../../../common/MessageBox";
import { IConfirmDialogParams } from "../../../../../common/ConfirmDialog";
import { IProjectRow } from "../../../../../webapi/service/getProjects";
import { IFileRow } from "../../../../../webapi/service/getFIles";

import FkdppSettingsFormContents from "./FkdppSettingsFormContents"

export interface IProps extends WithTranslation {
  /**
   * 認証サービス
   */
  authService?: AuthService;
  /**
   * 選択されたプロジェクト情報
   */
  projectInfo: IProjectRow;
  /**
   * ファイル情報一覧
   */
  rows: IFileRow[];
  /**
   * 戻るボタンが押された場合に呼び出されます
   */
  onBack: () => void;
  /**
   * プロジェクト一覧画面に戻る場合に呼び出します
   */
  onTop: () => void;
  /**
   * ファイル一覧をロードする場合に呼び出します
   * @param loading - ローディング画面を表示する場合はtrue
   */
  onLoadFiles: (loading: boolean) => void;
  /**
   * ローディング画面の表示非表示を切り替えます
   * @param loading - ローディング画面を表示する場合はtrue
   */
  onLoading: (loading: boolean) => void;
  /**
   * メッセージBoxを表示します
   * @param params - メッセージBoxパラメータ
   */
  showMessage: (params: IMessageBoxParams) => void;
  /**
   * 確認ダイアログを表示します。
   * @param params - 確認ダイアログパラメータ
   */
  showConfirm: (param: IConfirmDialogParams) => void;
  /**
   * 通信エラーが発生した場合に呼び出します
   * @param id - メッセージID
   * @param status - httpステータスコード
   */
  onCommunicationError: (
    id: string | undefined,
    status: number | undefined
  ) => void;
  /**
   * 非操作タイムアウトをリセットする場合に呼び出します
   */
  resetUnoperatedTimeout: () => void;
}

class FkdppSettingsForm extends React.Component<IProps> {
  
  constructor(props: IProps) {
    super(props);
  }

  getContents(): JSX.Element {
    let contents = <div />;
    contents = (
      <FkdppSettingsFormContents
        authService={this.props.authService}
        projectInfo={this.props.projectInfo}
        rows={this.props.rows} 
        onBack={this.props.onBack}
        onTop={this.props.onTop}
        onLoading={this.props.onLoading}
        showMessage={this.props.showMessage}
        showConfirm={this.props.showConfirm}
        onCommunicationError={this.props.onCommunicationError}
        resetUnoperatedTimeout={this.props.resetUnoperatedTimeout}
      />) 
    
    return contents;
  }

  render(): JSX.Element {
    const contents = this.getContents()
    return contents;
  }

}

export default withTranslation()(FkdppSettingsForm);


